module.exports = __webpack_public_path__ + "static/media/cidade 1.e14c3d61.svg";